var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 344,
    viewBox: "0 0 1440 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 300.255L1360 279.376C1280 257.503 1120 214.752 960 214.752C800 214.752 640 257.503 480 286.335C320 315.168 160 329.087 80 336.046L-3.00734e-05 344L0 -3.81849e-06L80 3.17534e-06C160 1.01692e-05 320 2.41568e-05 480 3.81444e-05C640 5.21321e-05 800 6.61197e-05 960 8.01074e-05C1120 9.4095e-05 1280 0.000108083 1360 0.000115076L1440 0.00012207L1440 300.255Z",
    fill: "#0055BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 300.255L1360 279.376C1280 257.503 1120 214.752 960 214.752C800 214.752 640 257.503 480 286.335C320 315.168 160 329.087 80 336.046L-3.00734e-05 344L0 -3.81849e-06L80 3.17534e-06C160 1.01692e-05 320 2.41568e-05 480 3.81444e-05C640 5.21321e-05 800 6.61197e-05 960 8.01074e-05C1120 9.4095e-05 1280 0.000108083 1360 0.000115076L1440 0.00012207L1440 300.255Z",
    fill: "url(#paint0_linear_453_5)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 300.255L1360 279.376C1280 257.503 1120 214.752 960 214.752C800 214.752 640 257.503 480 286.335C320 315.168 160 329.087 80 336.046L-3.00734e-05 344L0 -3.81849e-06L80 3.17534e-06C160 1.01692e-05 320 2.41568e-05 480 3.81444e-05C640 5.21321e-05 800 6.61197e-05 960 8.01074e-05C1120 9.4095e-05 1280 0.000108083 1360 0.000115076L1440 0.00012207L1440 300.255Z",
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_453_5",
    x1: 719.608,
    y1: 0.0000263532,
    x2: 719.997,
    y2: 344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/image3.8a4279b4c3440f2f0c93009a7326d1dd.svg";
export { ForwardRef as ReactComponent };